import React, { HTMLAttributeAnchorTarget } from 'react';
import { ExternalLink } from 'react-feather';

export type StyledLinkProps = {
  href?: string;
  target?: HTMLAttributeAnchorTarget;
  children: React.ReactNode;
};

export default function StyledLink({
  href,
  children,
  target,
}: StyledLinkProps) {
  return (
    <a
      className="text-brand font-semibold hover:underline inline-flex items-center"
      href={href}
      target={target}
    >
      {children}

      {target === '_blank' && (
        <div className="ml-1">
          <ExternalLink size={18} />
        </div>
      )}
    </a>
  );
}
